<template lang="html">
  <div>
    <d-form-row class="border mb-3">
      <table class="table mb-0 table-striped">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">Nome da classe</th>
            <th scope="col" class="border-0">Tipo</th>
            <th scope="col" class="border-0">Arquivo</th>
            <th scope="col" class="border-0">Opções</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(col, index) in model" :key="index">
            <td class="align-middle">
              <d-input v-model="col.name" placeholder="Nome da classe" />
            </td>
            <td class="td-3 align-middle">
              <d-select v-model="col.type_id">
                <option
                  v-for="option in quotationTypes"
                  :value="option.id"
                  :key="option.id"
                >
                  {{ option.name }}
                </option>
              </d-select>
            </td>
            <td class="align-middle">
              <div v-if="col.file && (col.file.url || col.file instanceof File)" class="flex row ml-1">
                <i class="fas fa-times-circle" @click="removeFile(index)"></i>
                <d-link :href="col.file.url" class="files__file-icon justify-center" target="_blank">
                  <i class="far fa-file-pdf custom-icon"></i>
                  <span class="d-block text-center">{{ col.file.original_name || col.file.file_name || col.file.name }}</span>
                  <span class="d-block text-center">Visualizar PDF</span>
                </d-link>
              </div>
              <input v-else type="file" class="form-control upload" @change="choseFile($event, index)">
            </td>
            <td class="td-1 text-right align-middle">
              <i class="fas fa-plus text-success" @click="addRow()" v-if="index + 1 == model.length"></i>
              <i class="fas fa-minus text-danger mx-3" @click="removeRow(index)"></i>
              <i class="fas fa-save" @click="save(index)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </d-form-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import SettingsService from '_services/rest/modules/settings';
import QuotationService from '_services/rest/modules/quotation';
import { ROW_CLASS } from './SettingsModel';

export default {
  name: 'presentation-form',
  data() {
    return {
      model: [this.createRow()],
      quotationTypes: null,
    };
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    createRow() {
      return {
        ...ROW_CLASS,
        file: { ...ROW_CLASS.file },
      };
    },
    addRow() {
      this.model.push(this.createRow());
    },
    checkEmptyClass() {
      if (this.model.length === 0) {
        this.model.push(this.createRow());
      }
    },
    getClasses() {
      SettingsService.getClasses()
        .then(response => {
          if (response.data.length) {
            this.model = response.data;
          }
        });
    },
    getQuotationTypes() {
      QuotationService.getTypeOptions()
        .then(response => {
          this.quotationTypes = response;
        });
    },
    removeRow(index) {
      SettingsService.removeClass(this.model[index].id)
        .then(() => {
          this.activeAlert({ message: 'Classe removida com sucesso', theme: 'success' });
          this.model.splice(index, 1);
          this.checkEmptyClass();
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    save(index) {
      SettingsService.saveClass(this.model[index])
        .then(() => {
          this.getClasses();
          this.activeAlert({ message: 'Classe salva com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    choseFile(event, index) {
      const [file] = event.target.files;
      if (!file) {
        return;
      }
      file.url = URL.createObjectURL(file);
      this.model[index].file = file;
    },
    removeFile(index) {
      this.model[index].file = null;
    },
  },
  mounted() {
    this.getClasses();
    this.getQuotationTypes();
  },
};
</script>

<style lang="scss" scoped>
.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }
}

.custom-icon {
  display: flex;
  justify-content: center;
  font-size: 2rem;
}
</style>
